<template>
  <v-tooltip left>
    <template v-slot:activator="{ on, attrs }">
      <div v-if="src" class="product-class mr-4" v-bind="attrs" v-on="on">
        <img aria-hidden :alt="pClass.name" :src="src" />
      </div>
    </template>
    <span>{{ pClass.name }}</span>
  </v-tooltip>
</template>
<script>
export default {
  name: "ProductClass",
  props: ["pClass"],
  computed: {
    src() {
      if (!this.pClass.iconSource && !this.pClass.url) return null;
      return this.pClass.iconSource || this.pClass.url;
    }
  }
};
</script>
